import React from 'react';
import classNames from 'classnames';

import Sticker, {
  Props as StickerProps,
} from 'components/Common/Sticker/Sticker';
import { getPriorityStickers } from 'services/listing/product';
import {
  formatMainSticker,
  formatCommercialOperationSticker,
} from 'services/product/formatter';

import styles from './ProductCardStickers.module.scss';

type PropsType = {
  mainSticker?: string;
  opecoSticker?: string;
  subSticker1?: string;
  subSticker2?: string;
  classes?: {
    container?: string;
    sticker?: string;
  };
};

type CommonStickerProps = {
  sticker: string;
} & Omit<StickerProps<'div'>, 'sticker'>;

const stickersPriorityOrder = [
  'opecoSticker',
  'subSticker1',
  'mainSticker',
  'subSticker2',
];

const renderComponents = {
  opecoSticker: OpecoSticker,
  subSticker1: PinkSticker,
  mainSticker: MainSticker,
  subSticker2: SubSticker,
};

export default function ProductCardStickers({
  mainSticker,
  opecoSticker,
  subSticker1,
  subSticker2,
  classes,
}: PropsType): JSX.Element {
  const displayedStickers = getPriorityStickers(
    { mainSticker, opecoSticker, subSticker1, subSticker2 },
    stickersPriorityOrder
  );

  return (
    <div className={classNames(styles.container, classes?.container)}>
      {displayedStickers.map(({ key, value }) => {
        const Comp = renderComponents[key];

        return <Comp key={key} sticker={value} className={classes?.sticker} />;
      })}
    </div>
  );
}

function MainSticker({ sticker, ...props }: CommonStickerProps): JSX.Element {
  const { label, image } = formatMainSticker(sticker);

  return (
    <Sticker
      sticker={{ label, image: image ? { src: image } : undefined }}
      {...props}
    />
  );
}

function SubSticker({ sticker, ...props }: CommonStickerProps): JSX.Element {
  return <Sticker sticker={{ label: sticker }} {...props} />;
}

function PinkSticker({
  sticker,
  className,
  ...props
}: CommonStickerProps): JSX.Element {
  return (
    <Sticker
      sticker={{ label: sticker }}
      className={classNames(styles.pinkColor, className)}
      {...props}
    />
  );
}

function OpecoSticker({ sticker, ...props }: CommonStickerProps): JSX.Element {
  const { label, background, color } = formatCommercialOperationSticker(
    sticker
  );

  return <Sticker sticker={{ label, background, color }} {...props} />;
}
